<template>
  <!-- <div class="home">
    <div style="padding-top:20px;  border: 1px solid #08396a;">
      <ul style="width:98%;margin:0 auto; display: flex;">
        <li style="width:39%;display: inline-block;margin-right:1.5%;height:421px;">
          <h4
            style="font-family:Microsoft YaHei;font-size: 16px; color: #dfecf7;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #08396A;margin-bottom:10px;"
          >
            <img
              style="display: inline-block;height:16px;margin-right:4px;"
              src="../assets/img/littleImg.png"
              alt
            />上市公司数量区域分布
          </h4>
          <div id="upmarket_echarts_map" style="width:612px;height:421px;"></div>
        </li>
        <li style="width:32%;display: inline-block;margin-right:1.5%;height:421px;">
          <h4
            style="font-family:Microsoft YaHei;font-size: 16px; color: #dfecf7;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #08396A;margin-bottom:10px;"
          >
            <img
              style="display: inline-block;height:16px;margin-right:4px;"
              src="../assets/img/littleImg.png"
              alt
            />各地区上市公司数量
          </h4>
          <div id="upmarket_echarts_num" style="width:100%;height:421px;"></div>
        </li>
        <li style="width:32%;display: inline-block;">
          <h4
            style="font-family:Microsoft YaHei;font-size: 16px; color: #dfecf7;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #08396A;margin-bottom:10px;"
          >
            <img
              style="display: inline-block;height:16px;margin-right:4px;"
              src="../assets/img/littleImg.png"
              alt
            />深圳证券交易所
          </h4>
          <div style="width:100%;height:210px;">
            <div style="height:100%;width:390px;margin:0 auto;position: relative;">
              <span
                style="display:block;position: absolute;top:90px;left:7%;width:110px;height:110px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0360B9);border-radius:50% 50%;"
              >
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 7;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count2[0] ? graph.count2[0].num : ''}}</i>
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count2[0] ? graph.count2[0].NAME : ''}}</i>
              </span>
              <span
                style="display:block;position: absolute;top:43px;left:46%;width:90px;height:90px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
              >
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 5.8;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count2[1] ? graph.count2[1].num : ''}}</i>
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count2[1] ? graph.count2[1].NAME : ''}}</i>
              </span>
              <span
                style="display:block;position: absolute;top:90px;left:68%;width:100px;height:100px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
              >
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 6.5;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count2[2] ? graph.count2[2].num : ''}}</i>
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count2[2] ? graph.count2[2].NAME : ''}}</i>
              </span>
              <span
                style="display:block;position: absolute;top:140px;left:42%;width:98px;height:98px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
              >
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 6;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count2[3] ? graph.count2[3].num : ''}}</i>
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count2[3] ? graph.count2[3].NAME : ''}}</i>
              </span>
            </div>
          </div>
          <h4
            style="font-family:Microsoft YaHei;font-size: 16px; color: #dfecf7;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #08396A;margin-bottom:10px;"
          >
            <img
              style="display: inline-block;height:16px;margin-right:4px;"
              src="../assets/img/littleImg.png"
              alt
            />上海证券交易所
          </h4>
          <div style="width:100%;height:210px;">
            <div style="height:100%;width:390px;margin:0 auto;position: relative;">
              <span
                style="display:block;position: absolute;top:90px;left:7%;width:110px;height:110px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0360B9);border-radius:50% 50%;"
              >
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 7;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count1[0] ? graph.count1[0].num : ''}}</i>
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count1[0] ? graph.count1[0].NAME : ''}}</i>
              </span>
              <span
                style="display:block;position: absolute;top:43px;left:44%;width:100px;height:100px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
              >
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 6.8;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count1[1] ? graph.count1[1].num : ''}}</i>
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count1[1] ? graph.count1[1].NAME : ''}}</i>
              </span>
              <span
                style="display:block;position: absolute;top:90px;left:70%;width:80px;height:80px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
              >
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 5;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count1[2] ? graph.count1[2].num : ''}}</i>
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count1[2] ? graph.count1[2].NAME : ''}}</i>
              </span>
              <span
                style="display:block;position: absolute;top:150px;left:51%;width:80px;height:80px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
              >
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 5;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count1[3] ? graph.count1[3].num : ''}}</i>
                <i
                  style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                >{{graph.count1[3] ? graph.count1[3].NAME : ''}}</i>
              </span>
            </div>
          </div>
        </li>
      </ul>
      <ul style="width:98%;margin:0 auto;">
        <li style="width:39%;display: inline-block;">
          <h4
            style="font-family:Microsoft YaHei;font-size: 16px; color: #dfecf7;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #08396A;margin-bottom:10px;"
          >
            <img
              style="display: inline-block;height:16px;margin-right:4px;"
              src="../assets/img/littleImg.png"
              alt
            />上市公司总数
          </h4>
          <div id="upmarket_allcount" style="width:100%;height:370px;overflow: hidden"></div>
        </li>
        <li style="width:53%;display: inline-block;margin-left:2%">
          <h4
            style="font-family:Microsoft YaHei;font-size: 16px; color: #dfecf7;font-weight:bold;height:36px;line-height:36px;border-bottom:1px solid #08396A;margin-bottom:10px;"
          >
            <img
              style="display: inline-block;height:16px;margin-right:4px;"
              src="../assets/img/littleImg.png"
              alt
            />全国各省出口及排名情况
          </h4>
          <div id="upmarket_echarts_work" style="width:100%;height:370px;overflow: hidden"></div>
        </li>
      </ul>
    </div>
  </div>-->
  <div class="rightChart">
    <div class="twoGraphBox">
      <div class="lefBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">上市公司数量区域分布</div>
        </div>
        <!-- 地图 -->
        <div id="upmarket_echarts_map" class="newgraph_box"></div>
      </div>
      <div class="ritBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">各地区上市公司数量TOP10</div>
        </div>
        <!-- 柱图 -->
        <div id="upmarket_echarts_num" class="newgraph_box"></div>
      </div>
    </div>

    <div class="twoGraphBox" style="height:350px;">
      <div class="lefBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">深圳证券交易所上市企业数量（家）</div>
        </div>
        <!-- 饼图 -->
        <div style="width:100%;height:100%;">
          <div style="height:100%;width:60%;margin:0 auto;position: relative;">
            <span
              style="display:block;position: absolute;top:90px;left:7%;width:110px;height:110px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0360B9);border-radius:50% 50%;"
            >
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 7;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count2[0] ? graph.count2[0].num : ''}}</i>
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count2[0] ? graph.count2[0].NAME : ''}}</i>
            </span>
            <span
              style="display:block;position: absolute;top:43px;left:46%;width:90px;height:90px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
            >
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 5.8;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count2[1] ? graph.count2[1].num : ''}}</i>
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count2[1] ? graph.count2[1].NAME : ''}}</i>
            </span>
            <span
              style="display:block;position: absolute;top:90px;left:68%;width:100px;height:100px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
            >
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 6.5;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count2[2] ? graph.count2[2].num : ''}}</i>
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count2[2] ? graph.count2[2].NAME : ''}}</i>
            </span>
            <span
              style="display:block;position: absolute;top:140px;left:42%;width:98px;height:98px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
            >
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 6;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count2[3] ? graph.count2[3].num : ''}}</i>
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count2[3] ? graph.count2[3].NAME : ''}}</i>
            </span>
          </div>
        </div>
      </div>
      <div class="ritBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">上海证券交易所上市企业数量（家）</div>
        </div>
        <!-- 横向柱图 -->
        <div style="width:100%;height:100%;">
          <div style="height:100%;width:60%;margin:0 auto;position: relative;">
            <span
              style="display:block;position: absolute;top:90px;left:7%;width:110px;height:110px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0360B9);border-radius:50% 50%;"
            >
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 7;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count1[0] ? graph.count1[0].num : ''}}</i>
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count1[0] ? graph.count1[0].NAME : ''}}</i>
            </span>
            <span
              style="display:block;position: absolute;top:43px;left:44%;width:100px;height:100px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
            >
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 6.8;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count1[1] ? graph.count1[1].num : ''}}</i>
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count1[1] ? graph.count1[1].NAME : ''}}</i>
            </span>
            <span
              style="display:block;position: absolute;top:90px;left:70%;width:80px;height:80px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
            >
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 5;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count1[2] ? graph.count1[2].num : ''}}</i>
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count1[2] ? graph.count1[2].NAME : ''}}</i>
            </span>
            <span
              style="display:block;position: absolute;top:150px;left:51%;width:80px;height:80px;background: radial-gradient(circle, rgba(3, 35, 72, 0.8), #0093A0);border-radius:50% 50%;"
            >
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;line-height: 5;font-style: normal;margin:0 auto;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count1[3] ? graph.count1[3].num : ''}}</i>
              <i
                style="display: block;width:86%;height: 50%;text-align: center;color: #fff;font-style: normal;margin:4px auto 0;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{graph.count1[3] ? graph.count1[3].NAME : ''}}</i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="twoGraphBox">
      <div class="lefBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">按规模分上市公司占比情况</div>
        </div>
        <!-- 饼图 -->
        <div id="upmarket_allcount" class="newgraph_box"></div>
      </div>
      <div class="ritBox">
        <!-- 标题 -->
        <div class="newTitle">
          <div class="newlittleImg">
            <img src="../assets/img/littleImg.png" alt />
          </div>
          <div class="newword">上市公司行业分布</div>
        </div>
        <!-- 纵向柱图 -->
        <div id="upmarket_echarts_work" class="newgraph_box"></div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import echarts from "echarts";
import chinaJson from "../../static/common/china.json";
export default {
  data() {
    return {
      //图形数据
      graph: {
        count1: [], //上海证券交易所数据
        count2: [], //深圳证券交易所数据
        tabBool: true, //tab切换
        tableData: [],
        tableOrderData: [], //表格有排序的集合
        tableColumnWidth: [], //表格各个列最大宽度
        creditCodes: {}, //获取点击每一个股票的creditCodes信息
        offset: 0, //page
        limit: 15,
        total: 0,
        currentPage: 1,
        boolTable: false, //判断当前表格是全局渲染还是条件搜索渲染
        defaultTable: true, //判断当前是默认表格还是筛选表格
        orderByCode: "",
        orderNum: 1,
        loading: false //tableloading状态
      }
    };
  },
  props: ["initEchart"],
  watch: {
    initEchart() {
      this.init();
    }
  },
  methods: {
    //可视化--上市公司总数
    echartsAllCount() {
      let myChart = echarts.init(document.getElementById("upmarket_allcount"));
      myChart.resize();
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}家 ({d}%)"
        },
        legend: {
          //图例
          x: "center",
          y: "top",
          left: 10,
          data: [],
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontWeight: 400
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["32%", "45%"], //半径
            avoidLabelOverlap: false,
            color: [
              "#177fe8",
              "#ef7041",
              "#a8d9ab",
              "#03aab9",
              "#88cff8",
              "#ded668",
              "#c0e272"
            ],
            // color: [
            //   "#0360B9",
            //   "#03AAB9",
            //   "#0DC6D7",
            //   "#45A5F8",
            //   "#177FE8",
            //   "#0E70CE",
            //   "#F4724A"
            // ],
            label: {
              show: false,
              position: "center",
              normal: {
                //指示线指示文字
                show: true,
                position: "outside",
                formatter: "{d}%",
                textStyle: {
                  fontWeight: 400,
                  fontSize: 14,
                  color: "#fff"
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false,
              normal: {
                //指示线指示文字
                show: true,
                length: 35,
                length2: 17,
                lineStyle: {
                  width: 1
                }
              }
            },
            itemStyle: {
              borderWidth: 1,
              borderColor: "#fff"
            },
            data: []
            // data: [
            //   { value: , name: "" },
            // ]
          }
        ]
      };

      api.upmarketAllCount().then(res => {
        let _data = res.data;
        option.series[0].data = _data;
        let tmpData = [];
        if (_data.length > 0) {
          for (let i = 0; i < _data.length; i++) {
            tmpData.push(_data[i].name);
          }
          option.legend.data = tmpData;
        }
        if (option && typeof option === "object") {
          myChart.setOption(option, true);
          window.onresize = myChart.resize;
        }
      });
    },
    //可视化--上市公司区域分布图
    echartsMap() {
      let myChart = echarts.init(
        document.getElementById("upmarket_echarts_map")
      );
      myChart.resize();
      let optionMap = {
        // backgroundColor: "#FFFFFF",
        // title: {
        //   show: false,
        //   text: "上市公司区域分布图",
        //   subtext: "",
        //   x: "center"
        // },

        tooltip: {
          //鼠标移上去时显示悬浮框
          trigger: "item",
          // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
          // padding: 0,
          formatter: "{b}\n{c}家"
        },

        //左侧小导航图标
        visualMap: {
          show: true,
          x: "left",
          y: "bottom",
          // min: 0,
          // max: 100,
          text: ["高", "低"],
          inRange: {
            color: ["#87cefa", "#dfed27", "#e6521b"]
          },
          textStyle: {
            color: "#fff",
            fontSize: 12,
            fontWeight: 400
          }
        },
        //配置属性
        series: [
          {
            name: "",
            type: "map",
            mapType: "china",
            roam: false,
            zoom: 1.2,
            label: {
              normal: {
                show: true //省份名称
              },
              emphasis: {
                show: false
              }
            },
            data: [] //数据
          }
        ]
      };
      api.upmarketMap().then(res => {
        let _data = res.data;
        optionMap.series[0].data = _data;
        if (optionMap && typeof optionMap === "object") {
          echarts.registerMap("china", chinaJson);
          myChart.setOption(optionMap);
          window.onresize = myChart.resize;
        }
      });
    },
    //可视化--上市公司数量
    echartsUpmarketNum() {
      let myChart = echarts.init(
        document.getElementById("upmarket_echarts_num")
      );
      myChart.resize();
      let option = {
        color: ["#1C83E8"],
        tooltip: {
          //鼠标移上去时显示悬浮框
          trigger: "item",
          // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
          // padding: 0,
          formatter: "上市公司数量：{c}家"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        yAxis: [
          {
            axisLine: { show: false }, //去掉线
            axisTick: { show: false }, //去掉点
            type: "category",
            data: [],
            axisLabel: {
              textStyle: {
                color: "#fff"
              }
            }
          }
        ],
        xAxis: [
          {
            type: "value",
            show: false
          }
        ],
        series: [
          {
            name: "上市公司数量",
            type: "bar",
            barWidth: "30%",
            radius: "2px",
            data: [],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#DFECF7",
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      };
      api.upmarketMap().then(res => {
        let _data = res.data;

        option.series[0].data = _data.slice(-10);
        let tmpData = [];
        if (_data.length > 0) {
          for (let i = 0; i < _data.length; i++) {
            tmpData.push(_data[i].name);
          }
          option.yAxis[0].data = tmpData.slice(-10);
        }
        if (option && typeof option === "object") {
          myChart.setOption(option);
          window.onresize = myChart.resize;
        }
      });
    },
    //可视化--上市公司新增数量随时间分布情况
    echartsUpmarketTimeNum() {
      let myChart = echarts.init(
        document.getElementById("upmarket_echarts_timeNum")
      );
      myChart.resize();
      let option = {
        color: ["#3398DB"],
        tooltip: {
          //鼠标移上去时显示悬浮框
          trigger: "item",
          // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
          // padding: 0,
          formatter: "{b}\n{c}家"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            axisLine: { show: true }, //去掉线
            axisTick: { show: false }, //去掉点
            type: "category",
            data: [],
            splitLine: {
              //去网格线
              show: false
            }
            // axisTick: {
            //     alignWithLabel: true
            // }
          }
        ],
        yAxis: [
          {
            type: "value",
            show: true,
            splitLine: {
              //去网格线
              show: false
            }
          }
        ],
        series: [
          {
            name: "上市公司新增数量随时间分布情况",
            type: "bar",
            barWidth: "30%",
            data: [],
            itemStyle: {
              normal: {
                label: {
                  show: false, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "black",
                    fontSize: 16
                  }
                }
              }
            }
          }
        ]
      };

      api.upmarketTimeNum().then(res => {
        let _data = res.data;
        option.series[0].data = _data;
        let tmpData = [];
        if (_data.length > 0) {
          for (let i = 0; i < _data.length; i++) {
            tmpData.push(_data[i].name);
          }
          option.xAxis[0].data = tmpData;
        }
        if (option && typeof option === "object") {
          myChart.setOption(option);
          window.onresize = myChart.resize;
        }
      });
    },
    //可视化--上市公司行业分布情况
    echartsUpmarketWork() {
      let myChart = echarts.init(
        document.getElementById("upmarket_echarts_work")
      );
      myChart.resize();
      let option = {
        visualMap: {
          show: false,
          min: 0,
          max: 2000,

          textStyle: {
            color: "#333",
            fontSize: 14,
            align: "right"
          },
          inRange: {
            color: [
              "#3B8CDB",
              "#8EC2F5",
              "#035CB2",
              "#0365C4",
              "#0D6CC9",
              "#2782DB",
              "#1B79D5"
            ] //
          }
        },
        tooltip: {
          //鼠标移上去时显示悬浮框
          trigger: "item",
          // backgroundColor: "transparent", //悬浮框最外层设置了默认padding;5,背景色灰色，如果要自定义，设置padding:0;或者背景色透明。
          // padding: 0,
          formatter: "{b}：\n{c}家"
        },
        series: [
          {
            type: "treemap",
            width: "100%",
            height: "95%",
            roam: false, //是否开启拖拽漫游（移动和缩放）
            // nodeClick: true, //点击节点后的行为,false无反应
            breadcrumb: {
              show: false
            },
            normal: {
              show: true,
              textStyle: {
                color: "#fff",
                fontSize: 14
              },
              borderWidth: 1,
              borderColor: "transparent"
            },
            data: []
          }
        ]
      };
      api.upmarketworkNum().then(res => {
        let _data = res.data;
        option.series[0].data = _data;
        if (option && typeof option === "object") {
          myChart.setOption(option);
          window.onresize = myChart.resize;
        }
      });
    },
    //可视化--上海证券交易所+深圳证券交易所
    echartsUpmarketImgOne() {
      let _this = this;
      api.upmarketImgOne().then(res => {
        let _data = res.data;
        _this.graph.count1 = _data;
      });

      api.upmarketImgTwo().then(res => {
        let _data = res.data;
        _this.graph.count2 = _data;
      });
    },
    init() {
      this.echartsUpmarketWork(); //上市公司行业分布情况
      this.echartsUpmarketImgOne(); //上海证券交易所
      this.echartsAllCount(); //上市公司总数
      this.echartsMap(); //上市公司区域分布图
      this.echartsUpmarketNum(); //上市公司数量
    }
  },
  mounted() {
    this.init();
    // this.echartsUpmarketTimeNum(); //上市公司新增数量随时间分布情况
    // this.fetchTreeData(); //股票搜索--树形图数据获取
    // this.searchTextFetchSelectFn(); //选择字段--下拉框数据获取
    // this.searchAllBtn(1, 1); //进入页面加载表格数据
    // this.bodyCloseAlert(); //点击空白关闭股票弹出框
  }
};
</script>
<style scoped lang="less">
@import "../assets/less/tableScrollbar.less";
.home {
  width: 100%;
  height: 100%;
}
@media screen and (min-width: 1400px) {
  .showTablesDiv {
    min-height: calc(70vh - 275px);
  }
}
@media screen and (max-width: 1399px) {
  .showTablesDiv {
    min-height: calc(70vh - 150px);
  }
}
/* scrollbar */
.rightChart::-webkit-scrollbar {
  width: 5px;
  height: 10px;
}
.rightChart::-webkit-scrollbar-thumb {
  background: #3583ed;
  border-radius: 5px;
}
.rightChart::-webkit-scrollbar-track {
  background: #dfdfdf;
  border-radius: 5px;
}
/* 针对IE的scrollbar */
.rightChart {
  scrollbar-face-color: #3583ed; /*3D表面（ThreedFace）*/
  scrollbar-highlight-color: #dfdfdf; /*3D界面的亮边（ThreedHighlight）*/
  scrollbar-shadow-color: #dfdfdf; /*3D界面的暗边（ThreedShadow）*/
  scrollbar-3dlight-color: #dfdfdf; /*亮边框*/
  scrollbar-arrow-color: #3583ed; /*方向箭头 */
  scrollbar-track-color: #dfdfdf; /*拖动区域(TrackBar)*/
  scrollbar-darkshadow-color: #dfdfdf; /*暗边框（ThreedDarkShadow）*/
}
/* 针对firefox的scrollbar */
.rightChart {
  scrollbar-color: #3583ed #dfdfdf;
  scrollbar-width: thin;
}
/* Edge 的scrollbar隐藏*/
/* .rightChart{
    -ms-overflow-style:none;
} */
// 可视化
.rightChart {
  width: auto;
  height: auto;
  margin-right: 20px;
  padding: 20px 20px 50px 20px;
  background: rgba(5, 43, 79, 0.3);
  border: 1px solid #08396a;
  display: flex;
  flex-wrap: wrap;
  // overflow-x: scroll;
  .twoGraphBox {
    width: 100%;
    overflow: hidden;
    margin-bottom: 15px;
    .lefBox {
      width: 49%;
      height: 550px;
      float: left;
      .newTitle {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #08396a;
        overflow: hidden;
        .newlittleImg {
          float: left;
          img {
            width: 12px;
            height: 12px;
          }
        }
        .newword {
          margin-left: 4px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #dfecf7;
          float: left;
        }
      }
      .newgraph_box {
        width: 100%;
        height: 530px;
        margin: 0 auto;
        overflow: hidden;
      }
    }
    .ritBox {
      width: 49%;
      height: 550px;
      float: right;
      .newTitle {
        width: 100%;
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #08396a;
        overflow: hidden;
        .newlittleImg {
          float: left;
          img {
            width: 12px;
            height: 12px;
          }
        }
        .newword {
          margin-left: 4px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #dfecf7;
          float: left;
        }
      }
      .newgraph_box {
        width: 100%;
        height: 530px;
        margin: 0 auto;
        overflow: hidden;
      }
    }
  }

  .bottom_timeLine {
    width: 100%;
    height: 100px;
    margin-top: 20px;
    // display: flex;
    // align-items: center;
    // box-sizing: border-box;
    // img {
    //   height: 41px;
    //   width: 41px;
    // }
    // .img {
    //   width: 28px;
    //   height: 28px;
    //   margin: 0 10px;
    // }
    // .thinBox {
    //   width: 100%;
    //   display: flex;
    //   flex-direction: column;
    // }
    // .thins {
    //   width: 100%;
    //   display: flex;
    //   align-items: center;
    //   justify-content: space-between;
    //   padding-top: 10px;
    //   cursor: pointer;
    //   p {
    //     font-size: 14px;
    //     font-family: Arial;
    //     font-weight: 400;
    //     color: #6d84a2;
    //   }
    // }
    // .thin {
    //   margin-top: 30px;
    //   width: 100%;
    //   height: 2px;
    //   background: rgba(48, 151, 254, 0.5);
    //   display: flex;
    //   align-items: center;
    //   justify-content: space-between;
    //   cursor: pointer;
    //   p {
    //     width: 10px;
    //     height: 10px;
    //     background: #177de5;
    //     border-radius: 50%;
    //     cursor: pointer;
    //   }
    //   p:hover {
    //     background: #d5ebff;
    //   }
    // }
    #timeLine {
      width: 100%;
      height: 100px;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chart3.vue